import axios from "axios";
import {loadLanguageAsync} from "@/main";
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;


const state = () => ({
    apiKey: null,
    userRoles: null,
    loading: false,
    user: null,
    tenant: null,
    selectOptions: {
        walletCurrency: [
            {value: 'FUN_COINS', text: 'Fun Coins'},
            {value: 'QUIZ_COINS', text: 'Quiz Coins'}
        ],
    },
    dictionaries: {
        country: [],
        sex: [],
        ['phone_codes']: []
    },
    filterStore: {
        players: null
    },
    locale: [],
    tag: [],
    resourceTag: [],
    isUserWithPendingKycStatus: false,
    isQuestionToVerifyError: false
})

// getters
const getters = {
    apiKey: state => state.apiKey,
    userRoles: state => state.userRoles,
    loading: state => state.loading,
    user: state => state.user,
    tenant: state => state.tenant,
    walletCurrency: state => state.selectOptions.walletCurrency,
    locale: state => state.locale.filter( l => l.status !== 'DELETED'),
    adminLocale: state => state.locale.filter(l => l.domainGroup === 'admin'),
    sex: state => state.dictionaries.sex,
    country: state => state.dictionaries.country,
    phoneCodes: state => state.dictionaries['phone_codes'],
    sexLabel: state => id => {
        const sex = state.dictionaries.sex.find(s => s.key == id);
        if (sex) {
            return sex.label
        } else {
            return '';
        }
    },
    filter: state => name => {
        return state.filterStore[name];
    },
    countryLabel: state => id => {
        const country = state.dictionaries.country.find(s => s.key === id);
        if (country) {
            return country.label
        } else {
            return '';
        }
    },
    tag: state => state.tag,
    resourceTag: state => state.resourceTag
}

// actions
const actions = {
    // eslint-disable-next-line no-unused-vars
    getTags({state, commit}) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/tag`)
                .then(resp => {
                    commit('setTag', resp.data.items);
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    postTags({commit}, {tags, referenceId} ) {
        commit('setLoader', true);
        return new Promise((resolve, reject) => {
            axios.post(`/api/resource-tag/${referenceId}`, tags)
                .then(resp => {
                    commit('setLoader', false);
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        })
    },
    postTag({commit}, payload) {
        commit('setLoader', true);
        return new Promise((resolve, reject) => {
            axios.post(`/api/tag`, payload)
                .then(resp => {
                    commit('setLoader', false);
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        })
    },
    // eslint-disable-next-line no-unused-vars
    deleteTag({commit, dispatch}, key) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/tag/${key}`)
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // eslint-disable-next-line no-unused-vars
    getResourceTags({state, commit}, referenceId) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/resource-tag/${referenceId}`)
                .then(resp => {
                    commit('setResourceTag', resp.data);
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // eslint-disable-next-line no-unused-vars
    getLocale({state, commit}, dict) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/cms/locale`)
                .then(resp => {
                    commit('setLocale', resp.data.items);
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // eslint-disable-next-line no-unused-vars
    getDictionary({state, commit}, dict) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/dictionary/${dict}/entry?limit=500`)
                .then(resp => {
                    commit('setDictionary', {dict: dict, items: resp.data.items});
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // eslint-disable-next-line no-unused-vars
    getWalletDictionary({state, commit}) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/wallet/dictionary`)
                .then(resp => {
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // eslint-disable-next-line no-unused-vars
    getTenant({state, commit}, id) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/tenant/tenant`)
                .then(resp => {
                    commit('setTenant', resp.data);
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // eslint-disable-next-line no-unused-vars
    getPlatformWallet({state, commit}, id) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/tenant/tenant/wallet`)
                .then(resp => {
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    fetchUserRoles({commit}) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/logged-user/role?limit=200`)
                .then(resp => {
                    let roles = [];
                    for(const i in resp.data.items) {
                        roles.push(resp.data.items[i].role);
                    }
                    commit('setUserRoles', roles);
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        })
    },
    fetchUser({commit}) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/logged-user`)
                .then(resp => {
                    commit('setUser', resp.data);
                    localStorage.setItem('defaultLocale', resp.data.profile.locale);
                    loadLanguageAsync(resp.data.profile.locale, false);
                    resolve(resp.data);
                })
                .catch(err => {
                    reject(err);
                });
        })
    },
    login({commit, dispatch}, payload) {
        commit('setLoader', true);
        return new Promise((resolve, reject) => {
            axios.post(`/api/auth-token`, payload)
                .then(resp => {
                    commit('setApiKey', resp.data.token);
                    localStorage.setItem('apiKey', resp.data.token);
                    dispatch('fetchUser').then(
                        () => {
                            commit('setLoader', false);
                            resolve(resp.data);
                        }
                    )
                })
                .catch(err => {
                    reject(err);
                });
        })
    },
    // eslint-disable-next-line no-unused-vars
    logout({commit, dispatch}, payload) {
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            localStorage.removeItem('apiKey');
            resolve(true);
        })
    },
    checkNumberOfPlayersWithKycPendingStatus({commit}) {
        axios.get(`/api/client-security/player?limit=1&offset=0&filters[kycStatus][0][value]=pending&filters[kycStatus][0][operator]=eq&sort[]=-createdAt`)
            .then(resp => {
                if (resp.data.items.length) {
                    commit('setIsUserWithPendingKycStatus', true);
                } else {
                    commit('setIsUserWithPendingKycStatus', false);
                }
            });
    },
    checkNumberOfQuestionsToVerifyError({commit}) {
        axios.get(`/api/question/wrong-question-report?limit=1&offset=0&sort[]=-lastReportedDate&filters[category][0][value]=to_be_verified&filters[category][0][operator]=eq`)
            .then(resp => {
                if (resp.data.items.length) {
                    commit('setIsQuestionToVerifyError', true);
                } else {
                    commit('setIsQuestionToVerifyError', false);
                }
            });
    },

}

// mutations
const mutations = {
    setTenant(state, data) {
        state.tenant = data;
    },
    setLocale(state, data) {
        state.locale = data;
    },
    setApiKey(state, data) {
        state.apiKey = data;
        axios.defaults.headers.common['X-AUTH-TOKEN'] = data;
    },
    setUser(state, data) {
        state.user = data;
    },
    setUserRoles(state, data) {
        state.userRoles = data;
    },
    setLoader(state, data) {
        state.loading = data;
    },
    setDictionary(state, data) {
        state.dictionaries[data.dict] = data.items
    },
    setFilter(state, data) {

        if (data.operator) {
            state.filterStore[data.storeName][data.filterName] = data;
        } else {
            state.filterStore[data.storeName][data.filterName] = data.value;
        }
    },
    initFilters(state, data) {
        state.filterStore[data.storeName] = {};
        data.filterNames.forEach(s => {
            state.filterStore[data.storeName][s] = null;
        })
    },
    setTag(state, data) {
        state.tag = data;
    },
    setResourceTag(state, data) {
        state.resourceTag = data;
    },
    setIsUserWithPendingKycStatus(state, data) {
        state.isUserWithPendingKycStatus = data;
    },
    setIsQuestionToVerifyError(state, data) {
        state.isQuestionToVerifyError = data;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
